import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { ApplyItemCardSkeleton } from '../../../components/apply-item-card/ApplyItemCardSkeleton';
import { ApplyModule } from '../../../store/features/apply/types';
import { ProfilePageHeaderSkeleton } from './ProfilePageHeaderSkeleton';

interface MassApplyPageSkeletonProps {
  type: ApplyModule;
}
export const MassApplyPageSkeleton: React.FC<MassApplyPageSkeletonProps> = ({ type }) => {
  return (
    <div>
      <ProfilePageHeaderSkeleton hideBtn />
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={1.5} justifyContent="space-between">
          <Grid item>
            <Skeleton variant="text" width="7.5rem" />
          </Grid>
          <Grid item>
            <Grid container spacing={1.5}>
              {_.times(2).map((_item, index) => (
                <Grid item key={index}>
                  <Skeleton variant="rectangular" width="7.5rem" height="2rem" />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2.5}>
        {_.times(2).map((_item, index) => (
          <Grid key={index} item xs={12} md={6} xl={4}>
            <ApplyItemCardSkeleton type={type} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
